import Login from "pages/auth/login/index";
import LoginOtp from "pages/auth/loginOtp/index";
import LoginSso from "pages/auth/loginSso/index";
import authNew from "pages/authNew";
import Redirect from "pages/redirect/RedirectPage";
import Dashboard from "pages/sales/dashboard/index";
import VendorOnboardingCreate from "pages/vendorOnboarding/VendorOnboardingCreate";
import VendorOnboardingEdit from "pages/vendorOnboarding/VendorOnboardingEdit";
import VendorOnboardingSubmittedPage from "pages/vendorOnboarding/index";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import ErrorBoundary from "services/utils/errorBoundary";
import {isWebView} from "services/utils/nativeBridge";
import ssoLoginTesting from "../pages/LoginTesting/ssoLoginTesting";
import PrivateRoute from "./privateRoutes";
import PublicRoute from "./publiceRoutes";

const Routers = ({ authenticated, checked }) => {
  return (
    <Router>
      <ErrorBoundary>
        {checked && (
          <Switch>
            <PublicRoute
              exact
              path="/sso-login-testing"
              restricted={true}
              authenticated={authenticated}
              component={ssoLoginTesting}
            />
            {isWebView() ? (
              <PublicRoute
                exact
                path={["/", "/login"]}
                restricted={true}
                authenticated={authenticated}
                component={authNew}
              />
            ) : (
              <PublicRoute
                exact
                path={["/", "/login"]}
                restricted={true}
                authenticated={authenticated}
                component={Login}
              />
            )}
            <PublicRoute
              exact
              path={["/", "/jankk_admin"]}
              restricted={true}
              authenticated={authenticated}
              component={LoginSso}
            />
            <PublicRoute
              exact
              path="/login-otp"
              restricted={true}
              authenticated={authenticated}
              component={LoginOtp}
            />
            <PublicRoute
              exact
              path="/sso-login"
              restricted={true}
              authenticated={authenticated}
              component={LoginSso}
            />
            <PublicRoute
              exact
              path="/redirect/:id"
              restricted={false}
              authenticated={authenticated}
              component={Redirect}
            />
            <PublicRoute
              exact
              path="/vendor-onboarding/submitted"
              restricted={false}
              authenticated={authenticated}
              component={VendorOnboardingSubmittedPage}
            />
            <PublicRoute
              exact
              path="/vendor-onboarding/edit/:vendorId"
              restricted={false}
              authenticated={authenticated}
              component={VendorOnboardingEdit}
            />
            <PublicRoute
              exact
              path="/vendor-onboarding/:firmName/:name/:email/:tokenUserId?"
              restricted={false}
              authenticated={authenticated}
              component={VendorOnboardingCreate}
            />
            <PrivateRoute
              strict
              path="/dashboard"
              component={Dashboard}
              authenticated={authenticated}
            />
          </Switch>
        )}
      </ErrorBoundary>
    </Router>
  );
};

Routers.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default Routers;
